<template>
  <div class="page-class page-user-list">
    <h1 class="page-title text-center">Closure Remarks</h1>
    <silver-coin-box :columns="columns" :rows="rows" :loading="loading" :show-list="true" list-text="New closure remark" empty-text="No closure remarks found." @list="$router.push('/qms/closure-remarks/new')" @edit="edit" @delete="remove" />
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import SilverCoinBox from '../../../components/SilverCoinBox.vue';

function responseTemplateId(item) {
  // eslint-disable-next-line no-underscore-dangle
  return item.templateId || item.id || item._id;
}

export default {
  name: 'ClosureRemarksList', components: { SilverCoinBox }, metaInfo: { title: 'Closure Remarks' },
  data() { return { columns: [
    { id: 'no', headerText: '#', textKey: 'rowNum', width: '8%' },
    { id: 'message', headerText: 'Remark', textKey: 'message', width: '52%' },
    { id: 'status', headerText: 'Status', textKey: 'status', width: '15%' },
    { id: 'actions', type: 'functions', headerText: 'Functions', width: '25%', functions: { edit: true, delete: true } }
  ] }; },
  computed: {
    ...mapState('qms', ['loading', 'responseTemplates']), ...mapState('darkMode', ['isDarkMode']),
    rows() { return this.responseTemplates.map((item, index) => { const id = responseTemplateId(item); return { ...item, id, templateId: id, rowNum: index + 1, status: item.isActive === false ? 'Inactive' : 'Active' }; }); }
  },
  mounted() { this.listResponseTemplates({ router: this.$router }); },
  methods: {
    ...mapActions('qms', ['listResponseTemplates', 'deleteResponseTemplate']),
    edit({ row }) { this.$router.push(`/qms/closure-remarks/${encodeURIComponent(row.templateId)}/edit`); },
    remove({ row }) { Vue.swal({ title: 'Delete this closure remark?', showCancelButton: true, confirmButtonText: 'Yes, delete', preConfirm: () => this.deleteResponseTemplate({ templateId: row.templateId, router: this.$router }) }); }
  }
};
</script>
